 // Scripting to handle tabs interaction
(function($){


// home Tabs
	$(".home-tab-content").hide();

	$(".wp-block-columns.home-tabs .wp-block-cover").click(function () {
	  	$(".home-tab-content").hide();
	  	var activeTab = $("a", this).attr("href");
		$(activeTab).css('display', 'flex');
		$('html, body').animate({scrollTop: '0px'}, 300);

	  	$(".wp-block-columns.home-tabs .wp-block-cover").removeClass("active");
	  	$(this).addClass("active");
	  	
	});
	$(".tab-close-button").click(function () {
		$(".home-tab-content").hide();
		$(".wp-block-columns.home-tabs .wp-block-cover").removeClass("active");

	});

})(jQuery);
